import { motion } from "framer-motion";
import { LOGOS } from "@/data/content";

export const LogoStrip = () => {
  return (
    <section id="partners" data-testid="logo-strip" className="bg-white py-20 md:py-32 px-5 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="font-outfit text-xs uppercase tracking-widest text-coral">The Squad</span>
            <h2 className="font-anton uppercase text-4xl md:text-6xl leading-none text-obsidian mt-4">
              Brands I&apos;ve <span className="text-blue">teamed up</span> with
            </h2>
          </div>
          <p className="font-outfit font-medium text-obsidian/60 max-w-sm text-sm md:text-base">
            Trusted by the biggest brands in the world 🌎
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {LOGOS.map((logo, i) => (
            <motion.a
              key={logo.name}
              href={logo.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.8, rotate: i % 2 ? 4 : -4 }}
              whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ type: "spring", stiffness: 140, damping: 12, delay: (i % 4) * 0.05 }}
              whileHover={{ rotate: i % 2 ? 4 : -4, scale: 1.06 }}
              className="group bg-white rounded-2xl h-28 md:h-32 flex items-center justify-center p-6 border-2 border-obsidian/10 hover:border-blue transition-colors cursor-pointer"
              data-testid={`logo-${logo.name}`}
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
